// Toggle body class when mobile menu opens
document.addEventListener('DOMContentLoaded', function() {
  const menuDrawer = document.querySelector('header-drawer');
  const detailsElement = menuDrawer ? menuDrawer.querySelector('details') : null;
  
  if (detailsElement) {
    // Listen for toggle event on details element
    detailsElement.addEventListener('toggle', function() {
      
      if (detailsElement.open) {
        document.body.classList.add('mobile-menu-open');
      } else {
        document.body.classList.remove('mobile-menu-open');
      }
    });
  }
});